import React, { useState, useEffect } from 'react';
import { withStyles, IconButton } from '@material-ui/core';
import { ThumbUp, ThumbDown } from '@material-ui/icons';
import classNames from 'classnames';

const AvaliacaoLike = ({ classes, onLike, onDislike, avaliacaoDefault, label }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
   
  setSelectedOption(avaliacaoDefault);
  }, [avaliacaoDefault]);

  const handleLike = () => {
    setSelectedOption('LIKE');
    onLike && onLike();
  };

  const handleDislike = () => {
    setSelectedOption('DISLIKE');
    onDislike && onDislike();
  };

  return (
    <div className={classes.container}>
      {label && <span className={classes.label}>{label}</span>}
      <div className={classes.buttonsContainer}>
        <IconButton
          id="prt-avl-btn-lik"
          className={classNames(classes.button, {
            [classes.selected]: selectedOption === 'LIKE'
          })}
          onClick={handleLike}
        >
          <ThumbUp fontSize='small'/>
        </IconButton>
        <IconButton
          id="prt-avl-btn-dis"
          className={classNames(classes.button, {
            [classes.selectedDislike]: selectedOption === 'DISLIKE'
          })}
          onClick={handleDislike}
        >
          <ThumbDown fontSize='small'/>
        </IconButton>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '10px',
    padding: '10px 0px'
  },
  buttonsContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#666'
  },
  button: {
    color: '#666',
    fontSize:'5px',
    padding: '0px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  },
  selected: {
    color: '#219A97 !important',
  },
  selectedDislike: {
    color: '#f44336 !important',
  }
};

export default withStyles(styles)(AvaliacaoLike);